module.exports = __webpack_public_path__ + "img/直播会议管理.9ed3893f.png";